var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg4 = function Svg4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    viewBox: "0 0 27 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.233 40L13.7904 34.0406H0L1.41586 28.6377L18.9158 0H26.25L8.32524 28.6609H15.178L18.1513 17.2522H25.089L22.1157 28.6609H25.4571L24.0413 34.0638H20.6998L19.1424 40H12.233Z",
    fill: "url(#paint0_linear_156_2379)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_156_2379",
    x1: 13.125,
    y1: 0,
    x2: 13.125,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069FF",
    stopOpacity: 0
  })))));
};
export { Svg4 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAyNyA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjIzMyA0MEwxMy43OTA0IDM0LjA0MDZIMEwxLjQxNTg2IDI4LjYzNzdMMTguOTE1OCAwSDI2LjI1TDguMzI1MjQgMjguNjYwOUgxNS4xNzhMMTguMTUxMyAxNy4yNTIySDI1LjA4OUwyMi4xMTU3IDI4LjY2MDlIMjUuNDU3MUwyNC4wNDEzIDM0LjA2MzhIMjAuNjk5OEwxOS4xNDI0IDQwSDEyLjIzM1oiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xNTZfMjM3OSkiIGZpbGwtb3BhY2l0eT0iMC4zIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTU2XzIzNzkiIHgxPSIxMy4xMjUiIHkxPSIwIiB4Mj0iMTMuMTI1IiB5Mj0iNDAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzAwNjlGRiIgc3RvcC1vcGFjaXR5PSIwLjUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDA2OUZGIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";